export const TASK_GRID_CODE = 'task';
